// 返回的消息类型
export enum MessageTypeEnum {
  PLANS = 'plans',
  CHART = 'chart',
  SUMMARY = 'summary',
  ERROR = 'error',
  TEXT = 'text'
}

// 消息的状态
export enum MessageStatusEnum {
  START = 'start', // 需要新建流式输出的消息
  PROCESS = 'process', // 需要拼接的流式输出的消息
  END = 'end', // 流失输出消息结束了, 消息内部的加载状态也要结束
  COMPLETE = 'complete', // 不需要流式输出的消息, 消息数据是完整的, 只需要新建, 不需要拼接
}

// 错误消息类型
export enum ErrorTypeEnum {
  PRE = 'pre_error_messgae',
  SUB = 'sub_error_message',
}

// 消息数据结构
export interface MessageData {
  type: MessageTypeEnum;
  title: string | undefined;
  content: string; // markdown 格式, 用于流式输出
  status: MessageStatusEnum;
  extra?: ChartAndTableData | ErrorTypeEnum // 图表数据或者错误消息类型
}

// 后端返回的接口数据格式
export interface AnalysisResult {
  output: MessageData[];
  reply_id: number;
  start_id: number;
  language: string; // 算法端返回的当前语言
  reasoning: string;
  // criticism: string;
  // next_action: string;
  // is_completed: boolean; // 分析任务是否已完成, 前端可以用来判断是否还要继续自动请求
  // task_type: 'task' | 'chitchat'; // task代表数据分析任务;  chitchat代表普通闲聊
  
}
// 后端返回的图表数据格式
export interface ChartAndTableData {
  chart_data: ChartData[][] | null; // 折线图柱状图数据
  chart_sum_data: ChartSumData[] | null; // 饼图数据
  chat_type: ('line' | 'bar' | 'pie' | 'table')[] | null; // 展示的图表类型: line, bar, pie, table
  column_name: ColumnName[] | null; // 表格列信息, 包含表格中英文名称和列数据的类型: date, number, percent, string;  date展示格式为 YYYY-MM-DD, number和percent展示格式为保留两位小数, string原样展示
  count: number; // 表格数据总条数
  file_info: {
    // 下载文件的信息
    url: string;
    type: string; // 文件类型 csv
    name: string;
    size: string;
  };
  metrics: string[] | null; // 展示的指标数据, 用于图表上方的指标切换功能
  table_data: TableData[] | null; // 表格数据
  title: string; // 图表标题
}
// 后端返回的用于展示折线图和柱状图的数据格式
export interface ChartData {
  dimension_name: string; // 图例名称
  // 指标数据
  metrics: {
    axisPoint: string; // 日期时间
    axisValues: {
      [key: string]: {
        // 指标名称, axisValues中可能会有多个指标
        value: string; // 指标的数据, 有正常数值和百分数两种
        percent: string; // 占比数据, 是个百分比
      };
    };
  }[];
}
// 后端返回的用于展示饼图的数据格式
export interface ChartSumData {
  [key: string]: {
    dimension_name: string; // 图例名称
    value: {
      value: string; // 数据, 有正常数值和百分数两种
      percent: string; // 在饼图中的占比
    };
  }[];
}
// 后端返回的表格列的信息
export interface ColumnName {
  name: string; // 表格列头的中文名称
  name_en: string; // 表格列头的英文名称
  type: number; // 前端逻辑没有用到, 具体的可以咨询后端
  column_date_type: 'date' | 'number' | 'percent' | 'string'; // 用来判断表格数据使用哪种展示格式
  can_sort: boolean; // 是否排序
}
// 后端返回的表格数据
export interface TableData {
  [key: string]: string;
}

// 前端解析转换后的折线图和柱状图的数据格式
export interface LineAndBarData {
  legendData: string[]; // 用于渲染图例
  seriesOfMetric: SeriesOfMetric;
  xAxisData: string[]; // 日期时间字符串
}
export interface SeriesOfMetric<T = any> {
  [key: string]: {
    name: string;
    data: SeriesData[];
    maxSortChartList?: T;
  }[];
}
export interface SeriesData {
  [key: string]: {
    // key是指标名称 由于指标切换功能, 所以要根据指标获取对应的series数据
    value: string;
    percent: string;
    value_type: 'number' | 'percent';
  };
}

// 前端解析转换后的饼图数据格式
export interface PieData {
  legendOfMetric: {
    [key: string]: string[]; // key是指标名称,
  };
  seriesOfMetric: {
    [key: string]: {
      name: string;
      percent: string;
      value: string;
    }[];
  };
}

// 前端解析转换后的表格数据格式
export interface ITableInfo {
  columnsInfo: ColumnsInfo[];
  data: {
    [key: string]: string; // key和ColumnsInfo中的key一一对应
  }[];
  total: number; // 表格数据的总条数
}
export interface ColumnsInfo extends ColumnName {
  key: string; // 前端新增的, 和name的值相同, 用于表格column中的key以及record中根据key获取到对应的数据, 避免name变化取不到值.
}

// 需要回传给算法端的每次任务分析的问题和结果
export interface BackInfo {
  role: 'user' | 'assistant'
  content: string
}
// 需要回传给算法端的图表标题和下载地址
export interface BackChartInfo {
  title: string
  url: string
}

// 聊天接口 前端上传参数
export interface ChatRequestParams {
  content?: string,
  session_id: string,
  stage: 'start' | 'stop',
  extra_info?: {
    domain: string,
    game_code: string,
    language: string,
    messages: BackInfo[],
    data: BackChartInfo[]
  },
  // 总结对话，之前一个接口，现在拆分2个接口，来处理
  url?: string
}

interface LanguageItem <S=string> {
  // 中文
  'cn_query': S;
  // 英文 
  'en_query': S;
}
export interface ParmptData {
  [key: string]: Array<LanguageItem>;
}

